/**
 * Push notification subscription manager
 */
import { BACKEND_URL } from './api';
import { getAnonId, getLeadId } from './tracker';

let swRegistration = null;

export async function initPushNotifications() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    return false;
  }
  try {
    swRegistration = await navigator.serviceWorker.register('/sw.js');
    return true;
  } catch (e) {
    console.warn('SW registration failed:', e);
    return false;
  }
}

export async function subscribeToPush() {
  if (!swRegistration) {
    const ok = await initPushNotifications();
    if (!ok) return null;
  }

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') return null;

  try {
    const res = await fetch(`${BACKEND_URL}/api/push/vapid-key`);
    const { public_key } = await res.json();
    if (!public_key) return null;

    const sub = await swRegistration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(public_key),
    });

    const subJson = sub.toJSON();
    await fetch(`${BACKEND_URL}/api/push/subscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        endpoint: subJson.endpoint,
        keys: subJson.keys,
        lead_id: getLeadId(),
        anon_id: getAnonId(),
        customer_id: null,
      }),
    });
    return sub;
  } catch (e) {
    console.warn('Push subscription failed:', e);
    return null;
  }
}

export async function isPushSubscribed() {
  if (!swRegistration) return false;
  try {
    const sub = await swRegistration.pushManager.getSubscription();
    return !!sub;
  } catch { return false; }
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}
